module.exports = __webpack_public_path__ + "img/app.ec022775.svg";